import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  navigation,
  studentNavigation,
  RefInfonavigation,
  NewRefInfonavigation,
  Menu4,
  Menu6,
  MenuSupport,
} from './navigation/navigation';
import { EntNavigationService } from './services/navigation/navigation.service';
import { KeycloakService } from './services/keycloak/keycloak.service';
import { EntNavigation } from './navigation/ent-navigation';
import { RouteStatusService } from './services/maintenance/route-status.service';
import { RouteStatus } from './models/services/maintenance/routeStatus.model';
import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  style,
} from '@angular/animations';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-main',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  style: string;
  navigation: EntNavigation[];
  studentNavigation: EntNavigation[];
  refinfoNavigation: EntNavigation[];
  newRefInfonavigation: EntNavigation[];
  menu4: EntNavigation[];
  menu6: EntNavigation[];
  menuSupport: EntNavigation[];

  // Splashscreen
  private splashScreenEl: HTMLElement;
  private player: AnimationPlayer;

  // Liste des chemins (routes) autorisés où la sidebar doit être masquée
  allowedPaths: string[] = [
    '/login',
    '/validation',
    '/start',
    '/errors/error-browser',
    '/password-recovery',
    '/password-change',
    '/password-reset',
    '/assistance',
    '/name-change',
  ];

  constructor(
    private router: Router,
    private _entNavigationService: EntNavigationService,
    keycloakService: KeycloakService,
    private routeStatusService: RouteStatusService,
    @Inject(DOCUMENT) private document: Document,
    private animationBuilder: AnimationBuilder
  ) {
    this.initSplashScreen();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        if (this.isPathAllowed(currentUrl)) {
          this.style = 'logout-layout'; // Masquer la sidebar
        } else if (keycloakService.isAuthenticated()) {
          this.style = 'logged-layout'; // Afficher la sidebar
        } else {
          this.style = 'logout-layout'; // Masquer la sidebar
        }
      }
    });

    // Get default navigation
    this.navigation = navigation;
    this.studentNavigation = studentNavigation;
    this.refinfoNavigation = RefInfonavigation;
    this.newRefInfonavigation = NewRefInfonavigation;
    this.menu4 = Menu4;
    this.menu6 = Menu6;
    this.menuSupport = MenuSupport;

    // Register the navigation to the service
    this._entNavigationService.register('main', this.navigation);
    this._entNavigationService.register('student', this.studentNavigation);
    this._entNavigationService.register('refinfo', this.refinfoNavigation);
    this._entNavigationService.register(
      'newrefinfo',
      this.newRefInfonavigation
    );
    this._entNavigationService.register('menu4', this.menu4);
    this._entNavigationService.register('menu6', this.menu6);
    this._entNavigationService.register('MenuSupport', this.menuSupport);
  }

  ngOnInit(): void {
    this.routeStatusService.updateNavigationMaintenanceStatus(this.navigation);
    this.routeStatusService.updateNavigationMaintenanceStatus(
      this.studentNavigation
    );
    this.routeStatusService.updateNavigationMaintenanceStatus(this.menu4);
    this.routeStatusService.updateNavigationMaintenanceStatus(this.menu6);
    this.routeStatusService.updateNavigationMaintenanceStatus(
      this.newRefInfonavigation
    );
    this.routeStatusService.updateNavigationMaintenanceStatus(this.menuSupport);

    // Set maintenance Settings in cache
    this.routeStatusService.getRouteStatuses().subscribe();
  }

  updateNavigation(data: RouteStatus[]): void {
    data.forEach(routeStatus => {
      this.navigation.forEach(navItem => {
        if (navItem.children) {
          navItem.children.forEach(childItem => {
            if (childItem.url === routeStatus.url) {
              childItem.maintenance = routeStatus.isDisabled;
            }
          });
        }
      });
    });
  }

  // Fonction pour vérifier si un chemin (route) est autorisé
  private isPathAllowed(path: string): boolean {
    return this.allowedPaths.some(pathArray => path.startsWith(pathArray));
  }

  private initSplashScreen(): void {
    // Get the splash screen element
    this.splashScreenEl =
      this.document.body.querySelector('#ent-splash-screen');

    // If the splash screen element exists...
    if (this.splashScreenEl) {
      // Hide it on the first NavigationEnd event
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.hideSplashScreen();
        }
      });
    }
  }

  /**
   * @description
   * Show the splash screen
   */
  private showSplashScreen(): void {
    this.player = this.animationBuilder
      .build([
        style({
          opacity: '0',
          zIndex: '99999',
        }),
        animate('400ms ease', style({ opacity: '1' })),
      ])
      .create(this.splashScreenEl);

    setTimeout(() => {
      this.player.play();
    }, 0);
  }

  /**
   * @description
   * Hide the splash screen
   */
  private hideSplashScreen(): void {
    this.player = this.animationBuilder
      .build([
        style({ opacity: '1' }),
        animate(
          '400ms ease',
          style({
            opacity: '0',
            zIndex: '-10',
          })
        ),
      ])
      .create(this.splashScreenEl);

    setTimeout(() => {
      this.player.play();
    }, 0);
  }
}
